import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import { ChevronRight } from '@carbon/icons-react';
import { CustomizedTypography } from '@components/Customized';
import useClient from '@hooks/useClient';
import ProfileUpdateDialog from '@components/Dialog/Account/ProfileUpdateDialog';
import Dialog from '@components/Dialog';

interface DisplayItemProps {
  label: string;
  value: string;
  onClick: ({ content, label }: { content: string; label: string }) => void;
}

const DisplayItem = ({ label, value, onClick }: DisplayItemProps) => {
  const { hasRequiredInfo } = useClient();
  const [requiredInfoPreDialogOpen, setRequiredInfoPreDialogOpen] = useState<
    boolean
  >(false);

  const [profileUpdateModal, setProfileUpdateModal] = useState(false);

  return (
    <>
      <Box
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'center'}
        style={{ cursor: 'pointer' }}
        onClick={() => {
          if (!hasRequiredInfo) {
            setRequiredInfoPreDialogOpen(true);
          } else {
            onClick({ content: value, label });
          }
        }}
      >
        <Box>
          <CustomizedTypography
            variant={'body1'}
            color={'textSecondary'}
            gutterBottoms={8}
          >
            {label}
          </CustomizedTypography>

          <CustomizedTypography variant={'body1'} fontWeight="500">
            {value}
          </CustomizedTypography>
        </Box>
        <Box>{hasRequiredInfo && <ChevronRight width={20} height={20} />}</Box>
      </Box>

      {profileUpdateModal && (
        <ProfileUpdateDialog
          open={profileUpdateModal}
          onClose={() => setProfileUpdateModal(false)}
        />
      )}

      {requiredInfoPreDialogOpen && (
        <Dialog.Account.ProfileUpdatePreviewDialog
          open={requiredInfoPreDialogOpen}
          onClose={() => {
            setRequiredInfoPreDialogOpen(false);
          }}
          onClick={() => {
            setProfileUpdateModal(true);
            setRequiredInfoPreDialogOpen(false);
          }}
        />
      )}
    </>
  );
};

export default DisplayItem;
